import {ITrainingRecordDocumentSummary} from '../../message-models/training-record-document-summary.interface';
import {Observable} from 'rxjs';
import {HttpClient, HttpEvent, HttpRequest} from '@angular/common/http';
import {SettingsProviderService} from '../../common/settings-provider.service';
import {BaseApiService} from '../../common/base-api.service';
import {Router} from '@angular/router';
import {DocumentTypeService} from '../../services/document-type.service';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TrainingRecordDocumentService extends BaseApiService {
  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'TrainingRecordDocument');
  }

  getAllTrainingRecordDocumentSummaries(companyId: string, trainingRecordId?: string, includeExpired?: boolean): Observable<ITrainingRecordDocumentSummary[]> {
    return this.post<ITrainingRecordDocumentSummary[]>('GetAllTrainingRecordDocumentSummaries', {trainingRecordId: trainingRecordId, companyId: companyId, includeExpired});
  }

  getTrainingRecordDocumentSummary(documentId: string): Observable<ITrainingRecordDocumentSummary> {
    return this.post<ITrainingRecordDocumentSummary>('GetTrainingRecordDocumentSummary', {documentId});
  }

  getTrainingRecordDocumentForViewOrDownload(documentId: string): Observable<HttpEvent<Blob>> {
    return this.http.request(new HttpRequest(
      'POST',
      this.baseUrl + 'GetTrainingRecordDocumentForViewOrDownload',
      {documentId},
      {
        reportProgress: true,
        responseType: 'blob'
      }));
  }

  createOrUpdateTrainingRecordDocument(TrainingRecordDocumentUpload: any): Observable<ITrainingRecordDocumentSummary> {
    return this.post<ITrainingRecordDocumentSummary>('CreateOrUpdateTrainingRecordDocument', TrainingRecordDocumentUpload);
  }

  deleteTrainingRecordDocument(documentId: string, companyId: string): Observable<ITrainingRecordDocumentSummary> {
    return this.post<ITrainingRecordDocumentSummary>('DeleteTrainingRecordDocument', {documentId, companyId});
  }
}
